// extracted by mini-css-extract-plugin
export default {"carousel":"tG-z"};